export default "__VITE_ASSET__CXspY8Ma__"